import requestReport from '@/utils/requestReport'
import requestError from '@/utils/requestError'

/* 用户行为上报 */
export function reportBehavior(data) {
    return requestReport({
        url: '/log',
        method: 'get',
        params: data
    })
}

/* js错误信息上报 */
export function reportError(data) {
    return requestError({
        url: '/a.png',
        method: 'get',
        params: data
    })
}